import React from 'react';
import GlobalStyle from './globalStyles';
import home from './pages/home/home';
import aboutus from './pages/aboutus/aboutus';
import productsandservices from './pages/productsandservices/productsandservices';
import projects from './pages/projects/projects';
import contactus from './pages/contactus/contactus';
import elevators from './pages/productdetails/elevators';
import escalators from './pages/productdetails/escalators';
import maintainance from './pages/productdetails/maintainance';
import { BrowserRouter as Router, Switch, Route } from 'react-router-dom';
import ScrollToTop from './components/ScrollToTop';
import { Navbar, Footer } from './components';

function App() {
  return (
    <Router>
      <GlobalStyle />
      <ScrollToTop />
      {/* <Navbar /> */}
      <Switch>
        <Route path='/' exact component={home} />
        {/* <Route path='/aboutus' component={aboutus} /> */}
        <Route path='/productsandservices' component={productsandservices} />
        <Route path='/projects' component={projects} />
        <Route path='/contactus' component={contactus} />
        <Route path='/elevators' component={elevators} />
        <Route path='/escalators' component={escalators} />
        <Route path='/maintainance' component={maintainance} />
      </Switch>
      {/* <Footer /> */}
    </Router>
  );
}

export default App;
